import React, { useEffect, useRef, useState } from 'react';
import { sizedImageUrl, viewportImageWidth } from '../utils/imageSizing';

// A <div> with a CSS background photo that only starts downloading once it's
// within ~one screen of the viewport. Browsers fetch every CSS background on
// the page immediately, whether visible or not — on a community page with 40+
// photo strips that was 35 MB before the visitor scrolled at all.
// `enabled={false}` (e.g. a carousel slide far from the current one) holds
// the download back even when on screen.
const LazyBackground = ({ url, enabled = true, style, className, children }) => {
  const ref = useRef(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    if (near || !ref.current) return;
    if (typeof IntersectionObserver === 'undefined') { setNear(true); return; }
    const obs = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { setNear(true); obs.disconnect(); }
    }, { rootMargin: '100% 0px' });
    obs.observe(ref.current);
    return () => obs.disconnect();
  }, [near]);

  const show = near && enabled && url;
  return (
    <div
      ref={ref}
      className={className}
      style={show ? { ...style, backgroundImage: `url(${sizedImageUrl(url, viewportImageWidth())})` } : style}
    >
      {children}
    </div>
  );
};

export default LazyBackground;
